(function(fd, $, void0){

    var $slider = $('.vtest__container');
    
    $slider.each(function(){
        
        var columns = $(this).data('columns') || 4;
        
        $(this).slick({
            
            rows: 0, // prevent unnecessary div
            infinite: false,
            autoplay: false,
            dots: true,
            speed: 500,
            arrows: false,
            fade: false,
            cssEase: 'linear',
            slidesToShow: columns,
            slidesToScroll: columns,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        
                    }
                },
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true
                    }
                }
            ]
        });
    });

})(fourdegrees, jQuery);
